import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CreateAssociatedFormComponent } from '../create-associated-form/create-associated-form.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { DocumentService } from '@app/shared/services';
import { CreateMxConnectFormComponent } from '../create-mx-connect-form/create-mx-connect-form.component';
import { SelectTemplateAssociatedOtherFormComponent } from '../select-template-associated-other-form/select-template-associated-other-form.component';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'manage-associated-form',
  templateUrl: './manage-associated-form.component.html',
  styleUrls: ['./manage-associated-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageAssociatedFormComponent implements OnInit, OnDestroy {
  selectDOntAdd = false;
  loadingItems = [{ id: 1 }, { id: 2 }, { id: 3 }];
  @Input() data;
  @Input() currentuserId;
  @Input() is_mx_btn_needed = false;
  @Input() manageType = 'contact';
  @Input() is_loading;
  @Input() associate_form_list = [];
  @Input() currentStep = 0;
  @Input() action_type_config_list = [];

  subscription: Subscription = new Subscription();
  @Output('getUpdatedData') getUpdatedData: EventEmitter<any> = new EventEmitter();
  constructor(private dialog: MatDialog, private cd: ChangeDetectorRef, private documentService: DocumentService) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  createForm() {
    if (this.action_type_config_list[this.currentStep].list.length > 0) {
      const sharedDialogRef = this.dialog.open(SelectTemplateAssociatedOtherFormComponent, {
        width: '680px',
        maxWidth: '90%',
        data: {
          manageType: this.manageType,
          currentStep: this.currentStep,
          action_type_config_list: this.action_type_config_list,
          templateList: this.action_type_config_list[this.currentStep].list,
        },
      });
      this.subscription.add(
        sharedDialogRef.afterClosed().subscribe((confirmation) => {
          if (confirmation?.success) {
            this.createFormPopup({
              action_type_current: this.action_type_config_list[this.currentStep],
              ...this.data,
              manageType: this.manageType,
              selectedId: confirmation.id,
            });
          }
        })
      );
    } else {
      this.createFormPopup({
        action_type_current: this.action_type_config_list[this.currentStep],
        ...this.data,
        manageType: this.manageType,
      });
    }
  }
  createFormPopup(data) {
    const sharedDialogRef = this.dialog.open(CreateAssociatedFormComponent, {
      width: '680px',
      maxWidth: '90%',
      data: data,
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation?.success) {
          this.getUpdatedData.emit();
        }
      })
    );
  }
  deleteUserFormAssociation(id, form_name, item) {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Remove',
        materialIcon: 'delete',
        text: `Are you sure you want to remove ${form_name}?`,
        proceedTitle: 'Remove',
      },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.documentService.deleteUserFormAssociation(this.currentuserId, item.formid, item.associatedformid).subscribe((result) => {
              this.getUpdatedData.emit();
              this.cd.markForCheck();
            })
          );
        }
      })
    );
  }

  connectMX(item) {
    const dialogRef = this.dialog.open(CreateMxConnectFormComponent, {
      width: '460px',
      height: '450px',
      data: {
        currentuserId: this.currentuserId,
        vault_form_id: this.data.vault_form_id,
        manageType: this.manageType,
        description: item.description,
        vault_user_form_id: this.data.vault_user_form_id,
      },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.getUpdatedData.emit();
        }
      })
    );
  }
  ngOnInit(): void {}
}
